import { useComponentTranslation } from '@tebuto/functions/translation.components'
import { DateTime } from 'luxon'
import { useContext, useMemo } from 'react'
import { BookingCalendarContext } from '../context'

export default function WeekdayFilters() {
    const { t } = useComponentTranslation()
    const { availableWeekdays, selectedWeekdays, setSelectedWeekdays } = useContext(BookingCalendarContext)

    // Sort weekdays to ensure Monday (1) to Sunday (7) order
    const sortedWeekdays = useMemo(() => [...availableWeekdays].sort((a, b) => a - b), [availableWeekdays])

    const toggleWeekday = (weekday: number) => {
        if (selectedWeekdays.includes(weekday)) {
            // Don't allow deselecting all weekdays
            if (selectedWeekdays.length > 1) {
                setSelectedWeekdays(selectedWeekdays.filter((day) => day !== weekday))
            }
        } else {
            setSelectedWeekdays([...selectedWeekdays, weekday])
        }
    }

    const selectAll = () => {
        setSelectedWeekdays([...availableWeekdays])
    }

    const allSelected = selectedWeekdays.length === availableWeekdays.length

    return (
        <div className="space-y-3">
            <div className="flex items-center justify-between">
                <h4 className="font-medium text-sm widget-text-primary">{t('booking.bookingCalendar.weekdays')}</h4>
                {!allSelected && (
                    <button
                        type="button"
                        onClick={selectAll}
                        className="text-xs widget-text-secondary hover:widget-text-primary transition-colors"
                    >
                        {t('booking.bookingCalendar.selectAll')}
                    </button>
                )}
            </div>

            {/* Weekday Pills */}
            <div className="flex flex-wrap gap-2">
                {sortedWeekdays.map((weekday) => {
                    const dayName = DateTime.fromObject({ weekday: weekday as 1 | 2 | 3 | 4 | 5 | 6 | 7 })
                        .setLocale('de')
                        .toFormat('ccc')
                    const isSelected = selectedWeekdays.includes(weekday)

                    return (
                        <button
                            key={weekday}
                            type="button"
                            onClick={() => toggleWeekday(weekday)}
                            className="w-10 py-1.5 rounded-full text-xs font-medium transition-all border text-center"
                            style={
                                isSelected
                                    ? {
                                          backgroundColor: 'var(--widget-primary-600)',
                                          borderColor: 'var(--widget-primary-600)',
                                          color: 'white'
                                      }
                                    : {
                                          backgroundColor: 'transparent',
                                          borderColor: 'var(--widget-border)',
                                          color: 'var(--widget-text-secondary)'
                                      }
                            }
                        >
                            {dayName}
                        </button>
                    )
                })}
            </div>
        </div>
    )
}
